module.exports = __webpack_public_path__ + "e-learning-app/static/img/school7.9a7e80f.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/ne/school7.png
// module id = EC6s
// module chunks = 1